// Who owns and operates Schnerp, as the legal pages, the site footer and the
// search-engine structured data name it. Schnerp Inc. is an Alberta
// corporation; the address is its registered office.
// test/conventions/companyLine.unit.test.js holds the marketing emails'
// footer (emails/_components/company-line.mjml) to the same name and address.
export const COMPANY = {
  legalName: "Schnerp Inc.",
  jurisdiction: "Alberta, Canada",
  streetAddress: "196 3 Avenue West",
  locality: "Drumheller",
  region: "AB",
  postalCode: "T0J 0Y4",
  countryCode: "CA",
  address: "196 3 Avenue West, Drumheller, Alberta T0J 0Y4, Canada",
  supportEmail: "help@schnerp.com",
};
